/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

// AUTOGENERATED BY glean_parser v19.2.0. DO NOT EDIT. DO NOT COMMIT.

import EventMetricType from '@mozilla/glean/private/metrics/event';

/**
 * User engaged the PostVerify/SetPassword form (first keystroke into the
 * password field).
 *
 * Generated from `post_verify_set_password.engage`.
 */
export const engage = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'post_verify_set_password',
    name: 'engage',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User submitted the PostVerify/SetPassword form.
 *
 * Generated from `post_verify_set_password.submit`.
 */
export const submit = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'post_verify_set_password',
    name: 'submit',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * Password creation failed on the PostVerify/SetPassword page.
 *
 * Generated from `post_verify_set_password.submit_frontend_error`.
 */
export const submitFrontendError = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'post_verify_set_password',
    name: 'submit_frontend_error',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User successfully set a password on the PostVerify/SetPassword page.
 *
 * Generated from `post_verify_set_password.success`.
 */
export const success = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'post_verify_set_password',
    name: 'success',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);

/**
 * User viewed the PostVerify/SetPassword page.
 * Renamed from `third_party_auth_set_password.view` in FXA-13475 since the
 * page now serves three sign-in flows (third-party-auth, passwordless OTP,
 * passkey). The `reason` extra carries which flow brought the user here.
 *
 * Generated from `post_verify_set_password.view`.
 */
export const view = new EventMetricType<{
  reason?: string;
}>(
  {
    category: 'post_verify_set_password',
    name: 'view',
    sendInPings: ['events'],
    lifetime: 'ping',
    disabled: false,
  },
  ['reason']
);
